import React from 'react'
import { Icon } from 'react-icons-kit'
import { refresh } from 'react-icons-kit/ionicons'

export default ({ onClick }) => (
  <button
    onClick={onClick}
    className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-6 py-3 rounded-lg transition-colors duration-200 flex items-center gap-2 text-lg"
  >
    <Icon icon={refresh} /> Refresh
  </button>
)
